import _ from "lodash";
import { MutableRefObject, useEffect, useRef } from "react";
import { continentsCentroidsAndZooms } from "../../services/centralStore";
import { getLatLngBounds } from "../../services/mapUtils";
import { setContinentRefresher } from "../../store/weatherSearchSlice";
import { useAppDispatch } from "../useAppDispatch";
import { useAppSelector } from "../useAppSelector";

interface UseZoomToContinentProps {
    mapRef: MutableRefObject<L.Map>;
    fromMainSearchForm: boolean;
}

export const useZoomToContinent = ({ mapRef, fromMainSearchForm }) => {
    const dispatch = useAppDispatch();
    const continent = useAppSelector(state => {
        return state.weatherSearch.searchProperties.continent.val as string
    });
    const continentRefresher = useAppSelector(state => {
        return state.weatherSearch.continentRefresher;
    });
    const results = useAppSelector(state => {
        return fromMainSearchForm ? state.weatherSearch.searchResultsExtended : state.weatherSearch.searchResults;
    });

    const previewZooming = useRef<{ continents?: string[], timeout?: number, currentContinent?: string }>({});


    useEffect(() => {
        if (!mapRef.current || !continent) return;
        const continentValues = continentsCentroidsAndZooms[continent];

        if (!fromMainSearchForm && continent == 'all' && results) {
            const { currentContinent } = previewZooming.current;
            let continents = _.uniq(results.map(r => r.continent))
            if (!continents || !continents.length) return;
            const possibleContinents = continents.filter(c => !['middle-east', 'central-america', 'australia'].includes(c));
            continents = possibleContinents.length ? possibleContinents : continents;
            const continentIndex = (continents || []).indexOf(currentContinent);
            let nextIndex = continentIndex + 1;
            nextIndex = nextIndex >= continents.length ? 0 : nextIndex;
            previewZooming.current.currentContinent = continents[nextIndex];
            const continentValues = continentsCentroidsAndZooms[previewZooming.current.currentContinent];
            mapRef.current.setMaxBounds([[-90, -180], [90, 180]])
            mapRef.current.fitBounds(getLatLngBounds(continentValues.bounds), { animate: false });
            previewZooming.current.timeout = setTimeout(() => {
                dispatch(setContinentRefresher(Math.random().toString(16)));
            }, 5000) as unknown as number;
        }
        else {
            const bounds = getLatLngBounds(continentValues.bounds);
            mapRef.current.setMaxBounds([[-90, -180], [90, 180]])
            mapRef.current.fitBounds(bounds, { animate: false });
            mapRef.current.setMaxBounds(bounds.pad(0.25));
        }
        return () => {
            if (previewZooming.current.timeout) {
                clearTimeout(previewZooming.current.timeout)
            }
        }
    }, [continent, continentRefresher]);
}